/**
 * Runtime-spiegel van het thema in `tailwind.css` (@theme). Tailwind v4 heeft geen
 * `resolveConfig`/JS-config meer; componenten die themawaarden in JavaScript nodig hebben
 * (styleguide, storybook-viewports, VProgressBar, VRangeSlider, useBreakpointsForElement)
 * gebruiken deze constanten. Wijzig je het thema, houd dan beide bestanden gelijk.
 */

/** De eigen kleuren uit @theme; zelfde vorm als het v3 `theme.colors`-object (met DEFAULT-keys). */
export const themeColors = {
  black: '#021f1d',
  white: '#ffffff',
  current: 'currentColor',
  inherit: 'inherit',
  transparent: 'transparent',
  avatar: {
    DEFAULT: 'var(--avatar-bg)',
    text: 'var(--avatar-text)',
  },
  menu: 'var(--menu-bg)',
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    250: '#dadada',
    300: '#d4d4d4',
    400: '#a3a3a3',
    DEFAULT: '#737373',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    950: '#0a0a0a',
  },
  blue: {
    50: '#e6efff',
    100: '#bfd8ff',
    200: '#99beff',
    300: '#73a3ff',
    400: '#4d89ff',
    DEFAULT: '#2369f9',
    500: '#2369f9',
    600: '#1e5de0',
    700: '#194fbf',
    800: '#133f99',
    900: '#0d2f73',
  },
  green: {
    50: '#e6f9ed',
    100: '#cff3db',
    200: '#9ee8b6',
    300: '#6fdd92',
    400: '#4bd577',
    DEFAULT: '#31dc72',
    500: '#31dc72',
    600: '#2bbb66',
    700: '#239a58',
    800: '#1c7a4a',
    900: '#145a3a',
  },
  red: {
    50: '#fce8ed',
    100: '#f9d1db',
    200: '#f4a3b7',
    300: '#ee7692',
    400: '#e9486e',
    DEFAULT: '#e31a4a',
    500: '#e31a4a',
    600: '#b6153b',
    700: '#88102c',
    800: '#5b0a1e',
    900: '#2d050f',
    950: '#170307',
  },
  orange: {
    200: '#fbf4eb',
    300: '#f2dcbf',
    400: '#ff9900',
    DEFAULT: '#f29322',
    500: '#f29322',
    700: '#cf7d1d',
  },
  info: {
    200: 'var(--info-xlight)',
    300: 'var(--info-light)',
    DEFAULT: 'var(--info)',
    500: 'var(--info)',
  },
  primary: {
    200: 'rgb(var(--primary-lighter-rgb))',
    300: 'var(--primary-light)',
    400: 'rgb(var(--primary-400-rgb))',
    DEFAULT: 'var(--primary)',
    500: 'var(--primary)',
    600: 'var(--primary-dark)',
    700: 'var(--primary-darker)',
    800: 'var(--primary-darkest)',
    900: 'rgb(var(--primary-900-rgb))',
  },
  purple: {
    DEFAULT: '#8a3ffc',
  },
  secondary: {
    300: 'var(--secondary-light)',
    DEFAULT: 'var(--secondary)',
    500: 'var(--secondary)',
    600: 'var(--secondary-dark)',
  },
  success: 'rgb(var(--success-rgb))',
  teal: {
    200: '#46e4dc',
    DEFAULT: '#0ea199',
  },
  'grey-accent': {
    100: '#fbfaf5',
    200: '#beb1a8',
  },
  yellow: {
    DEFAULT: '#f4ca64',
  },
  particulier: {
    DEFAULT: '#f9b00f',
  },
  scope: {
    accent: 'var(--scope-accent, #f9b00f)',
  },
};

/** Alle schermbreedtes: de Tailwind-defaults plus de eigen xs/3xl uit @theme. */
export const screens: Record<string, string> = {
  xs: '425px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  '3xl': '1912px',
};

/** Container-query-groottes (Tailwind v4 defaults; voorheen @tailwindcss/container-queries). */
export const containers: Record<string, string> = {
  '3xs': '16rem',
  '2xs': '18rem',
  xs: '20rem',
  sm: '24rem',
  md: '28rem',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem',
  '3xl': '48rem',
  '4xl': '56rem',
  '5xl': '64rem',
  '6xl': '72rem',
  '7xl': '80rem',
};
